<template>
  <div class="wrapper">
    <el-tabs
      :class="!showSecondTab && !showThirdTab ? 'hide_Header' : ''"
      v-model="activeNameVal"
      @tab-click="handleClick"
      :style="tabStyle"
    >
      <el-tab-pane name="first" label="纯色">
        <vueColorPicker v-model="color" :themeKey="request_prefix" @update="changeColorHandle" />
      </el-tab-pane>
      <el-tab-pane name="second" label="线性渐变" v-if="showSecondTab">
        <vueGradientPicker v-model="gradient" :themeKey="request_prefix" @update="changeColorHandle" />
      </el-tab-pane>
      <el-tab-pane name="third" label="径向渐变" v-if="showThirdTab">
        <vueRadialGradientPicker v-model="gadialGradient" :themeKey="request_prefix" @update="changeColorHandle" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import "../../common.css"
import vueGradientPicker from "./component/vueGradientPicker"
import vueRadialGradientPicker from "./component/vueRadialGradientPicker.vue"
import vueColorPicker from "./component/vueColorPicker.vue"
import LinearGradient from "./component/LinearGradient"
import RadialGradient from "./component/RadialGradient"
import { simpleDeepClone } from "utils"

export default {
  name: "cxBaseColor",
  props: {
    colorArr: {
      type: Object,
      require: true
    },
    themeKey: {
      type: String,
      require: true
    },
    activeName: {
      type: String,
      default: "first"
    },
    showSecondTab: {
      type: Boolean,
      default: false
    },
    showThirdTab: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vueGradientPicker,
    vueRadialGradientPicker,
    vueColorPicker
  },
  data() {
    return {
      color: undefined,
      gradient: undefined,
      gadialGradient: undefined,
      tabShow: {
        first: true,
        second: false,
        third: false
      }
    }
  },
  watch: {
    // 最开始不存在data属性，所以需要动态监听
    colorArr: {
      handler(val, oldVal) {
        // if (oldVal) return 
        if (val.hasOwnProperty("themeColorId") && val.type === "color") {
          // 需要将外层的colors数据同步到stops中的第一项
          val.data.stops[0][2].themeColorId = val.themeColorId
          val.data.stops[0][2].colorOpacity = val.colorOpacity
          val.data.stops[0][2].isThemeColor = val.isThemeColor
        }
        const valData = val.data && val.data instanceof LinearGradient ? val.data.toRaw() : val.data
        const color = new LinearGradient({
          ...valData,
          limit: 5
        })
        this.color = color
        const gradient = new LinearGradient({
          ...valData,
          limit: 5
        })
        this.gradient = gradient
        const gadialGradient = new RadialGradient({
          ...valData,
          limit: 5
        })
        this.gadialGradient = gadialGradient
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    activeNameVal: {
      get() {
        return this.activeName
      },
      set(val) {}
    },
    tabStyle: {
      get() {
        let left = "0px"
        let width = "74px"
        if (!this.showThirdTab) {
          width = "112px"
        }
        if (this.activeNameVal == "second") {
          if (this.showThirdTab) {
            left = "74px"
          } else {
            left = "116px"
          }
        } else if (this.activeNameVal == "third") {
          left = "154px"
        }
        return {
          "--translateX": left,
          "--width": width
        }
      }
    }
  },
  methods: {
    changeColorHandle(data) {
      let colorArr = simpleDeepClone(this.colorArr)
      colorArr.data = data
      if (colorArr.type === "color") { // 纯色需要同步更新外面的属性
        colorArr.colorOpacity = data.stops[0][2].colorOpacity
        colorArr.color = data.stops[0][0]
        colorArr.isThemeColor = data.stops[0][2].isThemeColor
      }
      this.$emit("update:colorArr", colorArr)
      sessionStorage.removeItem("historyValueCombine")
    },
    handleClick(tab) {
      let colorArr = simpleDeepClone(this.colorArr)
      sessionStorage.setItem("historyValueCombine", 1)
      this.handleColorData()  
      this.$emit("update:activeName", tab.name)
      if (tab.name == "first") {
        colorArr.data = this.color.getJson
        colorArr.type = "color"
        colorArr.label = "颜色"
      } else if (tab.name == "second") {
        colorArr.data = this.gradient.getJson
        colorArr.type = "linearGradient"
        colorArr.label = "线性渐变"
      } else if (tab.name == "third") {
        colorArr.data = this.gadialGradient.getJson
        colorArr.type = "radialGradient"
        colorArr.label = "径向渐变"
      }
      this.$emit("update:colorArr", colorArr)
    },
    handleColorData() {
      const val = simpleDeepClone(this.colorArr)
      const valData = val.data && val.data instanceof LinearGradient ? val.data.toRaw() : val.data
      const color = new LinearGradient({
        ...valData,
        limit: 5
      })
      this.color = color
      const gradient = new LinearGradient({
        ...valData,
        limit: 5
      })
      this.gradient = gradient
      const gadialGradient = new RadialGradient({
        ...valData,
        limit: 5
      })
      this.gadialGradient = gadialGradient
    }
  }
}
</script>

<style scoped lang="scss">
.toolbar .wrapper ::v-deep .el-tabs__content {
  overflow: unset;
  padding-bottom: 0;
}

.toolbar .wrapper ::v-deep .el-tabs__header {
  margin: 0;
  margin-bottom: 16px;
}

.toolbar .wrapper ::v-deep .el-tabs__active-bar {
  width: var(--width) !important;
  transform: translateX(var(--translateX)) !important;
}
::v-deep .hide_Header > .el-tabs__header {
  display: none;
}
</style>
